export default __webpack_public_path__ + "static/media/boxbag.008705ec.svg";